import { useEffect, useState, useCallback } from 'react';

// Simple light/dark theme hook using Tailwind's `dark` class on <html> and localStorage
export function useTheme() {
    const [theme, setTheme] = useState(() => {
        if (typeof window === 'undefined') return 'light';

        try {
            const stored = window.localStorage.getItem('theme');
            if (stored === 'light' || stored === 'dark') return stored;
        } catch (_) {
            // ignore
        }

        try {
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                return 'dark';
            }
        } catch (_) {
            // ignore
        }

        return 'light';
    });

    useEffect(() => {
        if (typeof document === 'undefined') return;
        const root = document.documentElement;
        if (theme === 'dark') {
            root.classList.add('dark');
        } else {
            root.classList.remove('dark');
        }
        try {
            window.localStorage.setItem('theme', theme);
        } catch (_) {
            // ignore
        }
    }, [theme]);

    const toggleTheme = useCallback(() => {
        setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
    }, []);

    return { theme, toggleTheme };
}

